const common = {
  message: {
    failureMessageUpload: 'Algo salió mal, vuelve a intentarlo'
  }
};

export default common;
